<template>
  <div class="col-xs-12 top-document" data-toggle="collapse" :data-target="'#collapse-'+ news.id" aria-expanded="false" :aria-controls="'collapse-'+ news.id">
    <table class="col-xs-12" style="">
      <tr :class="{selected: news.selected}">
        <td class="col-md-5 col-xs-5" style="vertical-align: middle">
          {{news.name}}
        </td>
        <td class="col-md-3 col-xs-3 ">
          <span v-html="news.provider[0].name" v-if="news.provider && news.provider[0]"></span>
        </td>
        <template v-if="news.datePublished">
          <td class="col-md-2 col-xs-2 " style="">{{news.datePublished| moment('DD/MM/YYYY')}}</td>
        </template>
        <template v-else>
          <td class="col-md-2 col-xs-2 " style=""></td>
        </template>
        <td class="col-md-1 col-xs-1 text-center" :class="{hidden: context.name !== 'expertResult'}" style="vertical-align: center">
          <select :id="'score-'+ news.id">
            <option value="3">3</option>
            <option value="2">2</option>
            <option value="1">1</option>
          </select>
        </td>
        <td class="col-md-1 col-sm-1 text-center" style="vertical-align: center">
          <dropdown-news v-model="news" :context="context"></dropdown-news>
        </td>
      </tr>
    </table>

    <div style="bottom: -9px;position: absolute;width: 100%">
      <span style="margin-left: 49%;background-color: white;">
        <button style="border-radius: 50px;font-size: 0.6rem;" class="btn btn-info btn-xs">
        <i class="fa fa-chevron-down"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<style scoped>
  .selected {
    border-left: 5px solid #3498db;
  }

  .dropdown-menu {
    min-width: 50px;
  }
  div > .dropdown > i {
    cursor: pointer;
  }

  .dropdown-expert-action > ul > li i{
    font-weight: bold;
    margin-right: 5px;
  }

  .dropdown-expert-action ul > li a{
    font-size: 12px;
  }

  .dropdown-expert-action ul > li{
    margin-bottom: 5px;
    font-size: 12px;
  }

  .top-document {
    cursor: pointer;
    /*max-height: 80px;*/
    padding: 15px 0;
    border-bottom: 1px solid #eaeaea;
  }
  .top-document:hover {
    background: #f5f5f5;
  }

</style>
<style>
  .br-theme-bars-horizontal .br-widget a {
    height: 10px !important;
    background-color: rgba(0, 123, 225, 0.3) !important;

  }

  .br-theme-bars-horizontal .br-widget a.br-active, .br-theme-bars-horizontal .br-widget a.br-selected {
    background-color: #007bff !important;
  }
</style>
<script>
import 'jquery-bar-rating/dist/jquery.barrating.min'
import 'jquery-bar-rating/dist/themes/bars-horizontal.css'
//import IsoCountries from 'i18n-iso-countries'
//import EnCountries from '../../iconFlag/en'
import DropdownNews from './DropdownNews'

//IsoCountries.registerLocale(EnCountries)

export default {
  components: {DropdownNews},
  name: 'NewsTop',
  props: ['value', 'context'],
  data () {
    return {
      topDocument: null,
      news: null
    }
  },
  watch: {
    value: function (val) {
      this.news = val
    },
    news: function (val, oldVal) {
      if (oldVal !== null) {
        this.$emit('input', val)
      }
    }
  },
  computed: {
   /* sourceType: function () {
      let patent = false
      this.author.docs.forEach((doc) => {
        if (doc.publication === 'European Patent Office') {
          patent = true
        }
      })

      return patent === true ? 'Patent Applicant' : 'Companies Database'
    }*/
  },
  methods: {
    initScore: (news) => {
      let score = 0
      if (news.score <= 0.1) {
        score = 1
      } else if (news.score <= 0.5) {
        score = 2
      } else {
        score = 3
      }
      let scoreElement = $('#score-' + news.id)

      scoreElement.barrating({
        theme: 'bars-horizontal',
        readonly: true,
        showSelectedRating: false,
        hoverState: false,
        reverse: true,
        initialRating: score
      })
    }
    /*  ,getIso: (affiliation) => {
        if (typeof affiliation !== 'undefined') {
          let iso = IsoCountries.getAlpha2Code(affiliation.country, 'en')
          if (typeof iso === 'undefined') {
            iso = IsoCountries.toAlpha2(affiliation.code)
          }
          return iso
        }
      },
      checked: function (event) {
        this.$emit('companyChecked', this.author)

        if (typeof event.stopPropagation !== 'undefined') {
          event.stopPropagation()
        }
      }
      */
  },
  beforeMount () {
    this.news = this.value

    //this.author.docs.sort(function (doc1, doc2) {
    //  return new Date(doc2.pubDate) - new Date(doc1.pubDate)
   // })

    //this.topDocument = this.author.docs[0]
  },
  updated () {
    this.initScore(this.news)
  },
  mounted () {
    this.initScore(this.news)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/NewsTop.vue